export default __webpack_public_path__ + "static/media/YAS0820.34I-37991_-25599_0.370d999b.jpg";